import { Reveal } from "./Reveal";

const VALUES = ["Crujiente siempre", "Ingredientes honestos", "Diversión en serio"];

const Nosotros = () => (
  <section id="nosotros" data-testid="nosotros-section" className="py-16 md:py-24">
    <div className="max-w-7xl mx-auto px-6 lg:px-8 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
      <Reveal>
        <p className="text-sm font-semibold uppercase tracking-widest text-brand-pink">El concepto</p>
        <h2 className="text-balance mt-3 font-display font-bold tracking-tight text-brand-charcoal text-3xl md:text-4xl">
          No venimos a hacer lo de siempre. Venimos a hacerlo{" "}
          <span className="text-brand-pink">CROC.</span>
        </h2>
        <p className="mt-6 text-base md:text-lg text-brand-charcoal/75 leading-relaxed">
          CROC LAB nace de una idea muy simple: la comida que más apetece también
          puede hacerse bien. Pan con carácter, rellenos generosos y ese crujido
          que se convierte en firma desde el primer bocado.
        </p>
        <p className="mt-4 text-base md:text-lg text-brand-charcoal/75 leading-relaxed">
          Somos una marca irreverente pero seria en lo importante: la calidad del
          producto, el trato con las personas y una experiencia reconocible cada
          vez que entras por la puerta.
        </p>
        <p className="mt-4 text-base md:text-lg text-brand-charcoal/75 leading-relaxed">
          CROC nace de una idea italiana.
          <br />
          Cuatro amigos italianos y una idea muy CROC.
          <br />
          Y crece en Valencia.
        </p>
        <ul className="mt-8 flex flex-wrap gap-3">
          {VALUES.map((value) => (
            <li
              key={value}
              data-testid={`nosotros-value-${value.toLowerCase().replace(/ /g, "-")}`}
              className="text-sm font-semibold text-brand-charcoal bg-white border border-brand-charcoal/10 rounded-full px-4 py-2"
            >
              {value}
            </li>
          ))}
        </ul>
      </Reveal>
      <Reveal delay={0.15} className="flex justify-center lg:justify-end">
        <figure className="relative">
          <img
            src="/brand/croc-poster.png"
            alt="Lámina de marca de CROC LAB: Crocca por fuera. Brutal por dentro."
            data-testid="nosotros-poster-image"
            className="w-72 md:w-96 h-auto rounded-3xl border-4 border-white shadow-xl rotate-2"
          />
          <figcaption className="sr-only">
            Crocca por fuera. Brutal por dentro.
          </figcaption>
        </figure>
      </Reveal>
    </div>
  </section>
);

export default Nosotros;
